import { render, staticRenderFns } from "./ReleaseNotes.vue?vue&type=template&id=e1ac4002&scoped=true"
import script from "./ReleaseNotes.vue?vue&type=script&lang=ts"
export * from "./ReleaseNotes.vue?vue&type=script&lang=ts"
import style0 from "./ReleaseNotes.vue?vue&type=style&index=0&id=e1ac4002&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1ac4002",
  null
  
)

export default component.exports